export default __webpack_public_path__ + "static/media/job-seeker-selected.401ce6a9.svg";